import React from 'react';

import Image from 'next/image';

import { HotelEventsViewModel } from '@api/index';
import { getEventDatesInfo } from '@utils/getEventDatesInfo';

import {
  Card,
  EventImage,
  Content,
  Title,
  Dates,
  Description,
  ActionRow,
  DetailButton,
  NextEventsWrapper,
  NextEventsTitle,
  NextEventsList,
  NextEventItem,
  LeftColumn,
  KrokiButton,
  TitleContainer,
} from './styled';

interface EventCardProps {
  data: HotelEventsViewModel;
  onShowDetails: (event: HotelEventsViewModel & { dates?: string[] }) => void;
  toggleKrokiModal?: () => void;
}

const HotelEventCard: React.FC<EventCardProps> = ({
  data,
  onShowDetails,
  toggleKrokiModal,
}) => {
  const {
    title,
    artistName,
    image,
    dates,
    shortDescription,
    description,
    eventImageGallery,
  } = data;
  const formattedDates = getEventDatesInfo(dates);
  const hasSeatingArrangementImage = Boolean(
    eventImageGallery?.find(
      (item) => item.hotelEventImageType === 'SeatingArrangement'
    )?.imageUrl
  );

  return (
    <Card>
      <LeftColumn>
        <EventImage>
          <Image
            src={image || '/static/images/placeholder-image.webp'}
            alt={title || artistName || ''}
            fill
            sizes='(max-width: 1200px) 100vw, 360px'
          />
        </EventImage>
        {formattedDates?.nextEvents?.length ? (
          <NextEventsWrapper>
            <NextEventsTitle>Yaklaşan Diğer Etkinlikler</NextEventsTitle>
            <NextEventsList>
              {formattedDates.nextEvents.map((d) => (
                <NextEventItem key={d}>{d}</NextEventItem>
              ))}
            </NextEventsList>
          </NextEventsWrapper>
        ) : null}
      </LeftColumn>
      <Content>
        <TitleContainer>
          {title ? <Title>{title}</Title> : null}
          {hasSeatingArrangementImage ? (
            <KrokiButton
              onClick={(e) => {
                e.stopPropagation();
                toggleKrokiModal?.();
              }}
            >
              Oturma Düzeni
            </KrokiButton>
          ) : null}
        </TitleContainer>
        {shortDescription || description ? (
          <Description text={shortDescription || description} />
        ) : (
          <div style={{ height: 150 }} />
        )}
        {formattedDates?.closestEvent ? (
          <Dates>{formattedDates.closestEvent}</Dates>
        ) : null}
        <ActionRow>
          <DetailButton
            className='swiper-no-swiping'
            onClick={() =>
              onShowDetails({
                ...data,
                dates: [
                  formattedDates.closestEvent,
                  ...(formattedDates?.nextEvents
                    ? formattedDates.nextEvents
                    : []),
                ],
              })
            }
          >
            Detaylı Bilgi
          </DetailButton>
        </ActionRow>
      </Content>
    </Card>
  );
};

export default HotelEventCard;
